import { useQuery } from '@tanstack/react-query';
import { http, returnIfNotFoundError } from 'services/http';
import { CARGO_TRIPS_MANY } from 'api/query-keys.ts';
import type { IGetCargoTripRes } from 'api/swagger';

export const useGetCargoTrips = (tripId?: number) => {
  return useQuery<IGetCargoTripRes[]>({
    queryKey: [CARGO_TRIPS_MANY, tripId],
    queryFn: async (): Promise<IGetCargoTripRes[]> => {
      try {
        const { data } = await http.get<IGetCargoTripRes[]>(`/v1/trips/${tripId}/cargo-trips`);
        return data;
      } catch (error) {
        return returnIfNotFoundError<[]>(error, []);
      }
    },
    retry: false,
    refetchOnWindowFocus: false,
    staleTime: 0,
    cacheTime: 0,
    enabled: !!tripId,
  });
};
